// extracted by mini-css-extract-plugin
export default {"Button":"a4nOaSMD","icon":"a4cXih6z","reverse":"gUn8KVXc","spinnerBox":"eD4NJN6I","spinner":"gNmxVqus","disabled":"AeTCGE3z","primary":"BktMd3u5","file_loader":"LK3LH0Bf","accent":"RuzjXyIF","navigation":"cCTJkbl3","buttonModalText":"_qFoHZfo","inverted":"ayurlLBp","red-text":"fqjXT3jj","xl":"uHTBToSH","l":"wSxPXidO","m":"_mvvSsBr","s":"vU2d0zwt","null":"LIc6qUM_"};
    if(module.hot) {
      // 1764331277651
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  